module.exports = __webpack_public_path__ + "static/media/clayton.3d2939ab.png";